import {AppProps} from '../app/interfaces'
import {connect} from '../runtime-context/connect'
import {AppLoaded as AppLoadedUnconnected} from './app-loaded'

export interface AppLoadedProps extends AppLoadedOwnProps {
  appLoaded: () => void
}

export interface AppLoadedOwnProps {
  appLoaded643: Function
}

const mapRuntimeToProps = ({actions}: AppProps) => ({
  appLoaded: actions.appLoaded
})

export const AppLoaded = connect<AppLoadedOwnProps>(mapRuntimeToProps)(AppLoadedUnconnected)
